import { Component, OnInit, ViewChild, TemplateRef, Input, ViewContainerRef } from '@angular/core';
import { NgxCmModalContext } from '../../models';
import { NgxComponentInternalService } from '../../ngx-cm-services/ngx-component.internal.service';

@Component({
  selector: 'ngx-cm-lazy',
  templateUrl: 'ngx-cm-lazy.component.html',
  styleUrls: ['ngx-cm-lazy.component.scss']
})
export class NgxCmLazyComponent implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  // start the loader
  loading = true;

  _context;
  @Input()
  set Context(context: NgxCmModalContext) {
    this._context = context;
    this.Init();
  };

  get Context() {
    return this._context;
  }

  constructor(
    private componentService: NgxComponentInternalService
  ) { }

  ngOnInit() { }

  async Init() {
    let componentFactory = await this.componentService.LoadComponentFactory(this.Context).toPromise();

    // create component
    let componentRef = this.container.createComponent(componentFactory);

    // stop the loader
    this.loading = false;

    // set inputs
    this.Context.ComponentContext.Input.forEach(i => {
      componentRef.instance[i.Name] = i.Value;
    });

    // set outputs
    this.Context.ComponentContext.Output.forEach(o => {
      componentRef.instance[o.Name].subscribe(value => {
        o.Trigger(value);
      });
    });
  }

}
